{
  "SLA": {
    "HEADER": "Service Level Agreements",
    "ADD_ACTION": "اضافه کردن SLA",
    "ADD_ACTION_LONG": "ایجاد سیاست SLA جدید",
    "DESCRIPTION": "قراردادهای سطح خدمات (SLA) قراردادهایی هستند که انتظارات واضحی را بین تیم شما و مشتریان تعریف می کنند. آنها استانداردهایی را برای زمان پاسخگویی و حل موضوعات تعریف می کنند، در قالب چارچوبی مه برای پاسخگویی ایجاد می کنند تجربه ای پایدار و با کیفیت را به مشتری ارائه می کنند.",
    "LEARN_MORE": "اطلاعات بیشتری درباره SLA",
    "COUNT": "{n} SLA | {n} SLAs",
    "LOADING": "در حال گرفتن SLAها",
    "SEARCH_PLACEHOLDER": "Search SLA...",
    "SEARCH": {
      "NO_RESULTS": "No SLA found matching your search"
    },
    "PAYWALL": {
      "TITLE": "برای ایجاد SLA بروز رسانی کنید",
      "AVAILABLE_ON": "قابلیت SLA فقط در نسخه Business و Enterprise وجود دارد.",
      "UPGRADE_PROMPT": "برای دسترسی به ویژگی‌های پیشرفته مانند مدیریت تیم، اتوماسیون، ویژگی‌های سفارشی و موارد دیگر، طرح خود را ارتقا دهید.",
      "UPGRADE_NOW": "حالا ارتقا دهید",
      "CANCEL_ANYTIME": "You can change or cancel your plan anytime"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "قابلیت SLA فقط در نسخه Business و Enterprise وجود دارد.",
      "UPGRADE_PROMPT": "برای دسترسی به ویژگی‌های پیشرفته مانند گزارش‌های حسابرسی، ظرفیت اپراتور و غیره، به یک طرح پولی ارتقا دهید.",
      "ASK_ADMIN": "لطفاً برای ارتقا با ادمین خود تماس بگیرید."
    },
    "LIST": {
      "404": "هیچ SLA در این حساب‌کاربری وجود ندارد.",
      "TABLE_HEADER": {
        "SLA": "SLA",
        "BUSINESS_HOURS": "Business hours"
      },
      "EMPTY": {
        "TITLE_1": "Enterprise P0",
        "DESC_1": "مسائلی که توسط مشتریان سازمانی مطرح می شود و نیاز به توجه فوری دارد.",
        "TITLE_2": "Enterprise P1",
        "DESC_2": "مسائلی که توسط مشتریان سازمانی مطرح می شود، باید به سرعت مورد تایید قرار گیرد."
      },
      "BUSINESS_HOURS_ON": "Turned on",
      "BUSINESS_HOURS_OFF": "Turned off",
      "RESPONSE_TYPES": {
        "FRT": "آستانه زمان اولین پاسخ",
        "NRT": "آستانه زمان پاسخ بعدی",
        "RT": "آستانه زمان حل موضوع",
        "SHORT_HAND": {
          "FRT": "FRT",
          "NRT": "NRT",
          "RT": "RT"
        }
      }
    },
    "FORM": {
      "NAME": {
        "LABEL": "نام SLA",
        "PLACEHOLDER": "نام SLA",
        "REQUIRED_ERROR": "نام SLA الزامی است",
        "MINIMUM_LENGTH_ERROR": "باید بیشتر از 2 کاراکتر باشد",
        "VALID_ERROR": "فقط حروف ، اعداد ، خط تیره و زیر خط مجاز است"
      },
      "DESCRIPTION": {
        "LABEL": "توضیحات",
        "PLACEHOLDER": "SLA برای مشتریان پولی"
      },
      "FIRST_RESPONSE_TIME": {
        "LABEL": "اولین زمان پاسخگویی",
        "PLACEHOLDER": "0"
      },
      "NEXT_RESPONSE_TIME": {
        "LABEL": "زمان پاسخگویی بعدی",
        "PLACEHOLDER": "0"
      },
      "RESOLUTION_TIME": {
        "LABEL": "زمان تا حل شدن مساله",
        "PLACEHOLDER": "۶۰"
      },
      "BUSINESS_HOURS": {
        "LABEL": "ساعت کاری",
        "PLACEHOLDER": "تنها در طول ساعات کاری"
      },
      "THRESHOLD_TIME": {
        "INVALID_FORMAT_ERROR": "آستانه باید یک عدد و بزرگتر از صفر باشد"
      },
      "EDIT": "ویرایش",
      "CREATE": "ايجاد كردن",
      "DELETE": "حذف",
      "CANCEL": "انصراف"
    },
    "ADD": {
      "TITLE": "اضافه کردن SLA",
      "DESC": "وعده های دوستانه برای خدمات عالی!",
      "API": {
        "SUCCESS_MESSAGE": "SLA با موفقیت اضافه شد",
        "ERROR_MESSAGE": "خطایی پیش آمد. لطفا دوباره امتحان کنید"
      }
    },
    "DELETE": {
      "TITLE": "حذف SLA",
      "API": {
        "SUCCESS_MESSAGE": "SLA با موفقیت حذف شد",
        "ERROR_MESSAGE": "خطایی پیش آمد. لطفا دوباره امتحان کنید"
      },
      "CONFIRM": {
        "TITLE": "تاییدیه حذف",
        "MESSAGE": "آیا مطمئن هستید که می خواهید حذف کنید ",
        "YES": "بله، حذف شود ",
        "NO": "خیر، نگه‌دار "
      }
    },
    "EVENTS": {
      "TITLE": "SLA های از دست رفته",
      "FRT": "زمان تا اولین پاسخ",
      "NRT": "زمان پاسخگویی بعدی",
      "RT": "زمان تا حل شدن مساله",
      "SHOW_MORE": "{count} بیشتر",
      "HIDE": "مخفی کردم {count} مورد"
    }
  }
}
